var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplyCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.899 3.81c.134.131.135.349.002.483l-9.927 9.925a.344.344 0 01-.485 0l-2.225-2.226-.485-.485L.1 8.827a.343.343 0 010-.484l2.226-2.226a.344.344 0 01.485 0L5.49 8.795a.344.344 0 00.485 0L13.17 1.6a.348.348 0 01.487-.001l2.24 2.21z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplyCheck);
export default __webpack_public_path__ + "static/media/ApplyCheck.016eeeb1dd1dd94b28c69efada1eea9c.svg";
export { ForwardRef as ReactComponent };